// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2131M","vLegacy":"SelectSecondary_vLegacy__2BzaG","error":"SelectSecondary_error__2Z58l","disabled":"SelectSecondary_disabled__2B19g"};